import Component from "./component";
import { generateClassName } from "./utils";
import { registerComponent } from "./jquery";
import { mmSwitch, mmSwitchOptions } from "@/types";
import { shapes } from "routes/scripts/constants";

class Switch extends Component<mmSwitchOptions> implements mmSwitch {
  private _dxSwitch!: DevExpress.ui.dxSwitch;

  constructor(element: HTMLElement, options?: mmSwitchOptions) {
    super(element, options);

    this._dxSwitch = ($(this._element) as any)
      .dxSwitch({
        accessKey: this._options.accessKey,
        activeStateEnabled: this._options.activeStateEnabled,
        disabled: this._options.disabled,
        elementAttr: {
          class: generateClassName(
            "switch",
            this._options.color!,
            this._options.size!,
            this._options.shape,
            this._options.className,
          ),
          ...(this._options.attributes ?? {}),
        },
       focusStateEnabled:this._options.focusStateEnabled,
        height: this._options.height,
        hint: this._options.hint,
        hoverStateEnabled: this._options.hoverStateEnabled,
        isDirty: this._options.isDirty,
        isValid: this._options.isValid,
        name: this._options.name,
       onContentReady: this._options.onContentReady,
        onDisposing: this._options.onDisposing,
        onOptionChanged: this._options.onOptionChanged,
        onInitialized: this._options.onInitialized,
        onValueChanged: this._options.onValueChanged,
        readOnly: this._options.readOnly,
        rtlEnabled: this._options.rtlEnabled,
        switchedOffText: this._options.switchedOffText,
        switchedOnText: this._options.switchedOnText,
        tabIndex: this._options.tabIndex,
       validationError: this._options.validationError,
        validationErrors: this._options.validationErrors,
        validationMessageMode: this._options.validationMessageMode,
        validationMessagePosition: this._options.validationMessagePosition,
        value: this._options.value,
        visible: this._options.visible,
        width: this._options.width,
        shape:this._options.shape,
       
      })
      .dxSwitch("instance");
  }

  public get value(): boolean {
    return this._dxSwitch.option("value") ?? false;
  }

  public set value(val: boolean) {
    this._dxSwitch.option("value", val);
  }

  public get readOnly(): boolean {
    const val = this._dxSwitch.option("readOnly");
    return val !== undefined ? val : false;
  }
  public set readOnly(val: boolean) {
    this._dxSwitch.option("readOnly", val);
  }

  public get disabled(): boolean {
    const val = this._dxSwitch.option("disabled");
    return val !== undefined ? val : false;
  }
  public set disabled(val: boolean) {
    this._dxSwitch.option("disabled", val);
  }

  public getDefaults(): Partial<mmSwitchOptions> {
    return {
      value: false,
      color: "primary",
      size: "md",
      shape: "round",
      visible:true,
       isValid: true,
  validationStatus: "valid"
    };
  }
}

registerComponent("mmSwitch", Switch);

export default Switch;
